import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Error404Component } from '../shared/errors/errors.module';

import { AppGuard } from '../../app.guard';
import { InvestmentsComponent } from './investments.component';
import { CompaniesComponent } from './companies/companies.component';
import { SharesComponent } from './shares/shares.component';
import { StocksComponent } from './stocks/stocks.component';
import { CryptosComponent } from './cryptos/cryptos.component';
import { ReitsComponent } from './reits/reits.component';
import { DividendsComponent } from './dividends/dividends.component';
import { FixedComponent } from './fixed/fixed.component';
import { StatementReaderComponent } from './statement-reader/statement-reader.component';


export const routes: Routes = [
  {
    path: 'investments',
    data: { title: 'Investments' },
    children: [
      // { path: '', redirectTo: 'companies', pathMatch: 'full' }, 
      { path: '', component: InvestmentsComponent, canActivate: [AppGuard] }, // Default route
      // The Overview is now the dashboard of /investments
      { path: 'overview', redirectTo: '', pathMatch: 'full' },
      { path: 'companies', component: CompaniesComponent, canActivate: [AppGuard] },
      { path: 'shares', component: SharesComponent, canActivate: [AppGuard] },
      { path: 'stocks', component: StocksComponent, canActivate: [AppGuard] },
      { path: 'cryptos', component: CryptosComponent, canActivate: [AppGuard] },
      { path: 'reits', component: ReitsComponent, canActivate: [AppGuard] },
      { path: 'dividends', component: DividendsComponent, canActivate: [AppGuard] },
      { path: 'fixed-incomes', component: FixedComponent, canActivate: [AppGuard] },

      { path: 'statement-reader', component: StatementReaderComponent, canActivate: [AppGuard] },

      { path: '**', component: Error404Component }, // Error 404
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvestmentsRoutingModule { }
